var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/device/historicalData","frame-title":"历史数据"}})
}
var staticRenderFns = []

export { render, staticRenderFns }